import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  const firstExtraIndex = packageIncludes.findIndex(item => item.kind === 'extra');
  return <section id="pricing" className="py-20 px-4 bg-mist relative" data-id="element-205" data-mp="1s7sl0hgc5sx2">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-206" data-mp="1x9rpjuntavvl">
        <div className="text-center mb-10" data-id="element-207" data-mp="1x6vnbu4xll1c">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-ink uppercase" data-id="element-208" data-mp="226rws8wee4oa">
            Your Complete <span className="text-forest" data-id="element-209" data-mp="2w0fwv5hgc05">Workplace Safety Atlas</span> Package
          </h2>
          <p className="text-graphite/80 text-sm md:text-base" data-id="element-210" data-mp="7ul7652rblcg">
            Everything You Need to Plan, Teach, Explain, Review & Assess Workplace Safety Training More
            Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-gold-soft border-2 border-gold rounded-3xl p-1 relative shadow-xl shadow-ink/10" data-id="element-211" data-mp="1hon51wrzhwy0">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-ink font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-212" data-mp="20gfzlvmpbq7u">
            <Sparkles size={14} data-id="element-213" data-mp="1rg1b6nefxv04" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-214" data-mp="1rhu8hc35z2vg">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-215" data-mp="k3r5sr4rxkev" />

            <p className="text-sm font-bold tracking-widest text-gold-dark mb-3" data-id="element-216" data-mp="hj2xezjcg9fb">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-mist border border-line rounded-xl p-4" data-id="element-217" data-mp="mft97ao48iux">
              <li className="text-xs font-bold tracking-widest text-forest" data-id="element-218" data-mp="7j29t1efz75b">
                THE COMPLETE 6-IN-1 VISUAL TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-219" data-mp="3uvcy5xhr7f46" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-forest" data-id="element-220" data-mp="3k395szqtwjo">
                      PLUS 5 EXCLUSIVE PROFESSIONAL BONUSES
                    </li>}
                  {itemIndex === firstExtraIndex && <li className="pt-2 border-t border-line" aria-hidden="true" data-id="element-221" data-mp="3bxjyr56c9nbj" />}
                  <li className={`flex items-start gap-2 text-sm ${item.kind === 'extra' ? 'font-bold uppercase tracking-wide text-ink' : 'text-graphite'}`} data-id="element-222" data-mp="3fznew73ydg35">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-gold shrink-0 mt-0.5" data-id="element-223" data-mp="36d2tjon4zljt" /> : <Check size={16} className="text-forest shrink-0 mt-0.5" data-id="element-224" data-mp="31et1vo0mf32y" />}
                    <span data-id="element-225" data-mp="3g7usavsggeg6">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-226" data-mp="3p2spif2myddb">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-227" data-mp="3p0zjn1zujx6d">
                <span className="text-2xl md:text-3xl text-ink font-semibold" data-id="element-228" data-mp="3l1qn5pdf9l74">YOUR PRICE:</span>
                <span className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gold" data-id="element-229" data-mp="2u9j3kpnnctv">
                  {PRICE_LABEL}
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-230" data-mp="hx1aquczpeij">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-graphite/60" data-id="element-231" data-mp="qshbzwg2qvy5">
              <span className="flex items-center gap-1.5" data-id="element-232" data-mp="vrli2e7pcdk9">
                <Lock size={12} className="text-forest" data-id="element-233" data-mp="3v5nuttr1zsa3" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-234" data-mp="301y2s3a6vh7">
                <Zap size={12} className="text-forest" data-id="element-235" data-mp="7zwlglnul2xi" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-236" data-mp="829b7kzukhl4">
                <Wallet size={12} className="text-forest" data-id="element-237" data-mp="czspgkwjoud2" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}